import { useBlockProps, BlockControls, RichText } from "@wordpress/block-editor";
import { ToolbarGroup, Button as WPButton } from "@wordpress/components";
import SidePanel from "./sidePanel";
import { t } from "drupal";
import { useState, useEffect } from "@wordpress/element";
import { sanitizeInput } from '../utilities/helpers';


function Edit({ attributes, setAttributes }) {
  const { quotation = "",
          name = "",
          textColorClass = "",
          quotationError = "" } = attributes;


  // console.log("pullquote edit: ", { quotation, name, textColorClass });

  // Strip out script and HTML
  const onChangeQuotation = (value) => {
    const cleanedText = sanitizeInput(value);
    setAttributes({ quotation: cleanedText });
  };

  // Strip out script and HTML
  const onChangeName = (value) => {
    const cleanedText = sanitizeInput(value);
    setAttributes({ name: cleanedText });
  };

  // For side panel input: strip out both <script> and all HTML to avoid crashes
    const onChangeQuotationSidePanel = (value) => {
      const cleanedText = sanitizeInput(value);
      setAttributes({ quotation: cleanedText });
    };

  // For side panel input: strip out both <script> and all HTML to avoid crashes
  const onChangeNameSidePanel = (value) => {
    const cleanedText = sanitizeInput(value);
    setAttributes({ name: cleanedText });
  };

  // Handle background color change
  const onChangeTextColorClass = (className) =>
    setAttributes({ textColorClass: className });



  /**
   * Dynamically checks for requried fields, update attributes with error flags that validation.js watches, and auto disable
   * save button when missing quotation
   **/

  useEffect(() => {

    const quotationError = !quotation?.trim();

    // console.log("edit.js validation state", {
    //   quotationError
    // });

    setAttributes({
      quotationError
    });
  }, [quotation]);

  return (
    <div {...useBlockProps()}>
      <BlockControls>
        <ToolbarGroup>
          <WPButton
            label={t("Pull-Quote Settings")}
            icon="text"
            disabled
          />
        </ToolbarGroup>
      </BlockControls>

      {(quotationError) && (
        <div className="editor-field-error-message">
          {quotationError ? t("Quotation is required") : ""}
        </div>
      )}

        <RichText
          tagName="p"
          value={quotation}
          onChange={onChangeQuotation}
          placeholder={t("The important piece is to see how these things all connect to people and the ecosystem we live in. That's what environmental health does best")}
          required
          className={`pullquote ${textColorClass} subhead ${quotationError ? "editor-field-error is-required" : ""}`}
        />


      <RichText
        tagName="p"
        value={name}
        onChange={onChangeName}
        placeholder={t("Michael Yost")}
        className={`pullquote-name subhead ${textColorClass}`}
      />

    <SidePanel
      quotation={quotation}
      name={name}
      textColorClass={textColorClass}
      onChangeQuotation={onChangeQuotationSidePanel}
      onChangeName={onChangeNameSidePanel}
      onChangeTextColorClass={onChangeTextColorClass}
    />
    </div>
  );
}

export default Edit;
